module.exports = __webpack_public_path__ + "static/media/azAsc.fc48a725.svg";